import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { OtpVerifyBody } from '~app/common/models/otp-verify-body';
import { OtpVerifyResponse } from '~app/common/models/otp-verify-response';
import { SendOtpRequest } from '~app/common/models/send-otp-request';
import { SendOtpResponse } from '~app/common/models/send-otp-response';
import { Status } from '../../models/response';
import { apiRoutes } from '../../routes/api/api-routes';
import { navigationRoutes } from '../../routes/navigation/navigation-routes';
import { HttpService } from '../../services/http/http.service';
import { UiUtilityService } from '../../services/ui-utility/ui-utility.service';

@Injectable({
    providedIn: 'root',
})
export class OtpVerificationService {
    private readonly httpService = inject(HttpService);
    private readonly uiUtilityService = inject(UiUtilityService);
    private readonly router = inject(Router);

    verifyOtp(otpVerifyBody: OtpVerifyBody, flowFrom?: string) {
        return this.httpService.post<OtpVerifyResponse>(apiRoutes.verifyOtp, otpVerifyBody).pipe(
            tap((res: OtpVerifyResponse) => {
                console.log('OtpVerifyResponse', res);
                if (res.status === Status.OK && res.verificationStatus) {
                    localStorage.setItem('token', res.token);
                    if (flowFrom === 'sendCustomer') {
                        localStorage.setItem('sendCustomerToken', res.token);
                    }
                } else {
                    this.uiUtilityService.handleError(res.responseMessage ?? res.errorMessage);
                }
                return res;
            }),
            catchError((error) => {
                this.uiUtilityService.handleError(error.message);
                return throwError(() => error);
            })
        );
    }

    resendOtp(sendOtpBody: SendOtpRequest) {
        return this.httpService.post<SendOtpResponse>(apiRoutes.sendOtp, sendOtpBody).pipe(
            tap((res) => {
                const data = res as SendOtpResponse;
                if (data.status === Status.OK) {
                    this.uiUtilityService.onSuccess(data.responseMessage);
                } else {
                    this.uiUtilityService.handleError(data.responseMessage ?? data.errorMessage);
                }
            }),
            catchError((error) => {
                this.uiUtilityService.handleError();
                return throwError(() => error);
            })
        );
    }

    // Method to handle login process
    processLogin(
        otpPurpose:
            | 'login'
            | 'resetPassword'
            | 'new-user-registration'
            | 'sendCustomerLogin'
            | 'sendCustomerRegistration'
            | 'sendCustomerResetPassword',
        returnUrl: string
    ): void {
        console.log('returnUrl', returnUrl, otpPurpose);
        if (otpPurpose === 'sendCustomerLogin' || otpPurpose === 'sendCustomerRegistration') {
            this.router.navigate([navigationRoutes.navigateToSendCustomerChooseFlow]);
        } else if (otpPurpose === 'sendCustomerResetPassword') {
            this.router.navigate([navigationRoutes.navigateToSendCustomerSetPassword]);
        } else if (otpPurpose === 'login') {
            this.router.navigate([navigationRoutes.navigateToAdminHome]);
        } else if (otpPurpose === 'resetPassword') {
            this.router.navigate([navigationRoutes.navigateToSetPassword]);
        } else {
            this.router.navigate([navigationRoutes.navigateToSendCustomerLogin]);
        }
    }
}
